// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._13kz_{width:100%}._3JnB_{border-bottom:2px solid #dcdddd}@media(max-width:767px){._3JnB_{padding-right:1rem;overflow-x:auto;white-space:nowrap}}._2uUHg{display:inline-block;min-width:-webkit-max-content;min-width:-moz-max-content;min-width:max-content;margin-right:2rem;padding-bottom:.5rem;cursor:pointer;border-bottom:2px solid rgba(0,0,0,0);-webkit-transition:all .3s cubic-bezier(.645,.045,.355,1);-o-transition:all .3s cubic-bezier(.645,.045,.355,1);transition:all .3s cubic-bezier(.645,.045,.355,1);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-size:18px;font-weight:500;line-height:25px;font-family:var(--heading-font);letter-spacing:.5px}._2uUHg,._2uUHg:hover{color:#595757}._2uUHg:last-child{margin-right:0}._1H26A{position:relative;color:#231815}._1H26A:after{content:\"\";position:absolute;display:block;width:100%;height:2px;bottom:-4px;bottom:-.25rem;background-color:#231815}.G9Yvq{padding:1.5rem 0}@media(max-width:767px){.G9Yvq{padding:1rem 0}}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"root": "_13kz_",
	"tabList": "_3JnB_",
	"tab": "_2uUHg",
	"tabSelected": "_1H26A",
	"container": "G9Yvq"
};
module.exports = exports;
